import { useContext } from 'react';

import type { TLiveValue } from './LiveContext';

import { LiveContext } from './LiveContext';

const useLive = (): TLiveValue => useContext(LiveContext);

export {
  useLive,
};
